import { inventoryVendorService } from "../../../../../Api/Services/InventoryService/inventoryVendor";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { IEditInventoryVendorResponse, IInventoryVendor } from "../../types";

// 1. Thunk for fetching a single vendor for editing
export const getEditInventoryVendorThunk = createServiceAsyncThunk<
    IEditInventoryVendorResponse, 
    number 
>(
    ACTION_NAMES.EDIT_INVENTORY_VENDOR, 
    (id) => inventoryVendorService.getEditInventoryVendor(id),
    ERROR_MESSAGES.EDIT_INVENTORY_VENDOR_FAILURE
);

// 2. Slice
const editInventoryVendorSlice = createGenericSlice<
    IEditInventoryVendorResponse,
    number
>(
    SLICE_NAMES.EDIT_INVENTORY_VENDOR_SLICE, 
    getEditInventoryVendorThunk
);

// 3. Actions and Selectors
export const {
    clearError: clearEditInventoryVendorError,
    clearSuccessMessage: clearEditInventoryVendorSuccess,
} = editInventoryVendorSlice.actions;

export default editInventoryVendorSlice.reducer;